import React from 'react'
import AnswerFieldTest from '../components/test/AnswerFieldTest'

const AnswerFieldTestPage: React.FC = () => {
  return <AnswerFieldTest />
}

export default AnswerFieldTestPage